import {Checkbox, Space} from "antd";
import {Controller, useFormContext} from "react-hook-form";
import {FormFieldError} from "../../../../../../design-system/form-field";
import {CreateKycDocumentUploadStepFormValues} from "../schema-validation";

export function CreateKycDocUploadConfirmAccuracyFormField() {
  const {control} = useFormContext<CreateKycDocumentUploadStepFormValues>();
  return (
    <div>
      <Controller
        control={control}
        name="confirmAccuracy"
        render={({field: {onChange, value, ref}, fieldState: {error}}) => (
          <Space size={8} direction="vertical" style={{display: "flex"}}>
            <Checkbox
              onChange={(e) => onChange(e.target.checked)}
              ref={ref}
              checked={value}
            >
              By submitting this form, you confirm that the information and documents
              provided are accurate and genuine.
            </Checkbox>
            <FormFieldError errorMessage={error?.message} />
          </Space>
        )}
      />
    </div>
  );
}
